import { createUseStyles } from 'react-jss';
export default createUseStyles({
    '@keyframes loader': {
        'from': { transform: 'rotate(0deg)' },
        'to': { transform: 'rotate(360deg)' }
    },
    root: {
        animation: '$loader linear 1s infinite'
    }
}, { name: 'AircraftSpinnerIcon' });
//# sourceMappingURL=styles.js.map